import { cn } from '@workspace/ui/lib/utils';
import { useEffect, useRef, type ReactNode } from 'react';

type HeaderShellProps = {
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  navClassName?: string;
};

const HeaderShell = ({ children, footer, className, navClassName }: HeaderShellProps) => {
  const headerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const headerEl = headerRef.current;
    if (!headerEl) return;

    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
    };

    updateHeaderHeight();

    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(headerEl);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--header-height');
    };
  }, []);

  return (
    <header ref={headerRef} className={cn('sticky top-0 z-30 bg-white', className)}>
      <nav
        role="navigation"
        className={cn(
          'relative flex items-center justify-between gap-3 px-2 py-2 md:px-4 border-b border-gray-65',
          navClassName,
        )}
      >
        {children}
      </nav>
      {footer}
    </header>
  );
};

export default HeaderShell;
